import * as React from 'react';
import { FocusedViewContext } from './context';

export const FocusedViewProvider = (props: { children: React.ReactNode }) => {
	const { children } = props;

	const [contactIds, setContactIds] = React.useState([]);
	const [selectedContactId, setSelectedContactId] = React.useState(null);

	const ctx = {
		contactIds,
		setContactIds,
		selectedContactId,
		setSelectedContactId,
	};

	return <FocusedViewContext.Provider value={ctx}>{children}</FocusedViewContext.Provider>;
};
